import { apiBomUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import { rest } from "src/common/rest";
import { zBom3Positions, ZBom3Positions } from "./ZBom3Position";

// https://qa04.test.omndt.ru/gateway-service/services/bom-service/swagger-ui/index.html#/

const urlBomPositionV4 = (path: string = "") =>
  apiBomUrl(`/v4/api/bom-position${path}`);

export const loadBom3Positions = async (
  bomEntityId: ZUid,
): Promise<ZBom3Positions> => {
  const resp = await rest.get(urlBomPositionV4("/table"), {
    params: { bomEntityId },
  });
  return zBom3Positions.parse(resp.data);
};

export const saveBom3Value = async (
  bomEntityId: ZUid,
  rowId: ZUid,
  columnId: ZUid,
  value: string | null,
): Promise<ZBom3Positions> => {
  // Здесь пришлось использовать такой сложный вариант из-за того что иначе в query-параметр value попадали некорректные символы из JSON
  const params = new URLSearchParams({
    bomEntityId: String(bomEntityId),
    rowId: String(rowId),
    columnId: String(columnId),
  });
  // есть договорённость, что в случае value=NULL, параметр не передаётся
  if (value !== null) params.append("value", value);

  const resp = await rest.put(urlBomPositionV4("/value"), undefined, {
    params,
  });
  return zBom3Positions.parse(resp.data);
};

/**
 * Аналог saveBom3Value, но предназначен для уведомления о пересчитанных значениях формул
 * Не возвращает никакого результата.
 * */
export const sendBom3Value = async (
  bomEntityId: ZUid,
  rowId: ZUid,
  columnId: ZUid,
  value: string | null,
): Promise<void> => {
  const params = new URLSearchParams({
    bomEntityId: String(bomEntityId),
    rowId: String(rowId),
    columnId: String(columnId),
  });
  // есть договорённость, что в случае value=NULL, параметр не передаётся
  if (value !== null && value !== "") params.append("value", value);

  await rest.put(urlBomPositionV4("/value-only"), undefined, { params });
};

export const createBom3EmptyPosition = async (
  bomEntityId: ZUid,
  sectionId: ZUid,
): Promise<ZBom3Positions> => {
  const resp = await rest.post(urlBomPositionV4("/row"), undefined, {
    params: { bomEntityId, sectionId },
  });
  return zBom3Positions.parse(resp.data);
};

export const deleteBom3Positions = async (
  bomId: ZUid,
  rowIds: ZUid[],
): Promise<ZBom3Positions> => {
  // метод delete сейчас не возвращает ничего. Поэтому результат формируется вторым запросом
  await rest.delete(urlBomPositionV4("/row"), { data: rowIds });
  return loadBom3Positions(bomId);
};
